<template>
  <div class="w-100">
    <div class="accordion">
      <b-card no-body>
        <b-card-header @click="setIsOpen" header-tag="header" role="tab">
          <div class="row">
            <div class="col-6 accordion__title">
              <b-icon
                  icon="arrow-down-short"
                  variant="dark"
              >
              </b-icon>
              <strong>
                {{ $t('modal.segment.gender_rule_title') }}
              </strong>
            </div>
            <div class="d-flex justify-content-end align-items-center col-6 text-right">
              <p v-if="isEdited" class="text-danger mr-5 mb-0">{{ $t('error.segment.segment_is_edited') }}</p>
              <p v-if="v.value.$dirty && v.value.$invalid" class="text-danger mr-5 mb-0">{{ $t('error.segment.segment_required') }}</p>
              <button @click="destroy" class="btn btn-xs btn-danger delete-translation-btn">{{ $t('btn.segment.delete_segment') }}</button>
            </div>
          </div>
        </b-card-header>
        <b-collapse :visible="isOpen" accordion="gender" role="tabpanel">
          <div class="row p-4 d-flex justify-content-center align-items-start" style="height: 300px;">
            <div class="col-6">
              <p>{{$t('segment.set_gender')}}</p>
            </div>
            <div class="col-6">
              <multiselect
                  @input="emitSelectedValue"
                  :state="!v.value.$dirty ? null :(!v.value.$error)"
                  v-model="value"
                  :options="options.genderRule"
                  :multiple="true"
                  track-by="value"
                  label="text">
              </multiselect>
              <div class="">
                <p v-if="v.value.$dirty && v.value.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                <button v-if="isEditType" :disabled="!isEdited" @click="saveEditedRule" class="float-right mt-4 btn btn-xs btn-success">{{ $t('btn.segment.save_edited_rule') }}</button>
              </div>
            </div>
          </div>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
  import {userSegment} from "../../../../common/constants/userSegment";
  import Multiselect from "vue-multiselect";

  export default {
    components: {
      Multiselect
    },
    props: {
      v: {
        type: Object,
        required: true
      },
      genderForm: Object,
      isEditType: {
        type: Boolean,
        default: false
      },
      ruleId: {
        type: String,
        default: null,
        required: false
      },
      methodPost: {
        type: Boolean,
        required: false
      }
    },
    computed: {
      isEdited: function () {
        return this.$store.getters[`userSegment/getEditedRule`](userSegment.gender);
      }
    },
    mounted() {
      this.$parent.$on('checkValidation', () => {
        this.v.$touch();
      });

      if(this.genderForm.value.length > 0) {
        this.value = this.genderForm.value;

        this.value = this.options.genderRule.filter(rule => {
          if(this.genderForm.value.includes(rule.value)) {
            return rule;
          }
        });
      }
    },
    data() {
      return {
        isOpen: false,
        value: [],
        options: {
          genderRule: [
            { value: null, text: this.$t('segment.option.gender_placeholder'), $isDisabled: true },
            { value: 'MALE', text: this.$t('segment.option.gender.male') },
            { value: 'FEMALE', text: this.$t('segment.option.gender.female') },
            { value: 'UNDEFINED', text: this.$t('segment.option.gender.undefined') }
          ]
        }
      }
    },
    methods: {
      saveEditedRule() {
        this.$parent.$emit('editRule', {type: userSegment.gender, ruleId: this.ruleId, methodPost: this.methodPost});
      },
      deleteSegmentRule() {
        this.$parent.$emit('deleteSegmentRule', this.ruleId);
      },
      destroy() {
        const data = {
          component: this,
          rule: userSegment.gender,
          ruleId: this.ruleId
        }

        this.$parent.$emit('removeGenderRule', data);
      },
      setIsOpen() {
        if(this.isEditType && !this.isEdited) {
          this.isOpen = !this.isOpen;
          return;
        } else if(this.isEditType && this.isEdited) {
          return;
        }

        this.isOpen = !this.isOpen;
      },
      emitSelectedValue() {
        if(this.isEditType) {
          const data = {
            key: userSegment.gender,
            value: true
          }

          this.$store.commit('userSegment/setEditedRule', data);
        }
        this.$parent.$emit('selectedGender', {val: this.value});
      }
    }
  }
</script>